module.exports = __webpack_public_path__ + "static/media/contactBlue.ce6964ad.png";